import { DataProvider, Identifier, Record } from "react-admin";
import { create, findAndAction, findOne, update } from "../common/common";
import { createNextTasks } from "../task/actions";
import { fillTime } from "../task/list";

export interface ProductionUniCreate extends ProductionUnit {
    numberProductionUnits: number;
    automaticIncrementName: boolean;
};

export interface ProductionUnit extends Record {
    id: Identifier;
    name: string;
    quantity: number;
    comment: string;
    lotId: Identifier
};

export const createProductionUnits = async (dataProvider: DataProvider, receive: ProductionUniCreate) => {
    const { name, numberProductionUnits, automaticIncrementName, ...rest } = receive;
    const incrementName = automaticIncrementName && numberProductionUnits > 1;
    for (let i = 1; i <= numberProductionUnits; i++) {
        const data = {
            ...rest,
            name: incrementName ? `${name} ${i}` : name
        }
        await create(dataProvider, "production_unit", data);
    }
};

export const productionUnitIsMaybeDone = async (dataProvider: DataProvider, id: Identifier, quantityReal: number) => {
    const taskNotComplete = await findOne(dataProvider, "task", { productionUnitId: id, taskStatus: ["available", "assigned"] });
    if (!taskNotComplete) {
        const data = { tracking: "completed", quantityReal };
        const productionUnit = await update(dataProvider, "production_unit", id, data);
        const lotId = productionUnit.lotId;
        const hasOneNotCompleted = await findOne(dataProvider, "production_unit", { lotId, tracking: ["inProgress", "waiting"] });
        if (!hasOneNotCompleted) {
            // We need update the task
            await findAndAction(dataProvider, "task", { subprojectLotId: lotId, taskStatus: "assigned" }, async (previousData) => {
                let total = 0;
                await findAndAction(dataProvider, "lot_time", { id: lotId }, ({ consumedTime }) => {
                    total += consumedTime;
                });
                const data = fillTime(total);
                await update(dataProvider, "task", previousData.id, { ...data, taskStatus: "completed" }, previousData);
                await createNextTasks(dataProvider, previousData, "outgoing");
            });
            // We mark the lot has done
            await update(dataProvider, "lot", lotId, { tracking: "completed" });
        }
    }
};